import { render, staticRenderFns } from "./MissingModuleError.vue?vue&type=template&id=5811ee43&scoped=true"
import script from "./MissingModuleError.vue?vue&type=script&lang=js"
export * from "./MissingModuleError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5811ee43",
  null
  
)

export default component.exports